module.exports = __webpack_public_path__ + "media/images/city_img/title_1-922ae8b181a17157d771349329ab6723.png";